import React from "react"
// Component
import { HelmetProvider } from "react-helmet-async"
import { UserProvider, AuthProvider, AlertRoot, OperatorProvider } from "hooks"
import { BikeRegistrationProcessProvider, BikesStoreProvider } from "features/dashboard/hooks"

export const Providers: React.FC<{ children: React.ReactNode }> = ({ children }) => {
	return (
		<UserProvider>
			<AuthProvider>
				<OperatorProvider>
					<BikesStoreProvider>
						<BikeRegistrationProcessProvider>
							<HelmetProvider>
								<>{children}</>
								<AlertRoot />
							</HelmetProvider>
						</BikeRegistrationProcessProvider>
					</BikesStoreProvider>
				</OperatorProvider>
			</AuthProvider>
		</UserProvider>
	)
}
